module.exports = __webpack_public_path__ + "img/5.ab53702f.png";